// eslint-disable react/no-unescaped-entities
import React from 'react'

import Title from '@cinch/oxd-components/page-title/src'
import RichText from '@cinch/oxd-components/rich-text/src'

import * as styles from './holding.module.css'

interface HoldingProps {
  path: string
}

const HoldingComponent: React.FC<HoldingProps> = () => {
  return (
    <>
      <Title>Back soon</Title>
      <section className={styles.main}>
        <RichText>
          <p>
            Unfortunately, we&apos;re temporarily delaying all vehicle valuations and purchases at this stage of the
            Covid-19 crisis.
          </p>
          <p>
            As soon as we are able, we will update this page and resume the hassle-free way to sell your vehicle. In the
            meantime{' '}
            <a href="https://www.cinch.co.uk/post/what-to-do-before-you-sell-your-car">
              here are some tips to get your car ready to sell.
            </a>
          </p>
          <p>On behalf of everyone at cinch we would like to sincerely apologise for any inconvenience caused.</p>
          <p>Thank you for your understanding.</p>
        </RichText>
      </section>
    </>
  )
}

export default HoldingComponent
